import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import Questionnaire1Screen from '~/pages/homes/sexual-health/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/sexual-health/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/sexual-health/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/sexual-health/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/sexual-health/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/sexual-health/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/sexual-health/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/sexual-health/Questionnaire8Screen';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {SEXUAL_HEALTH_KEYS} from '~/constants/medical-questionnaires';
import {trackPageViewGA} from '~/services/google-analytics';

const SexualHealth = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case SEXUAL_HEALTH_KEYS.START:
        trackPageViewGA('/sexual-health/start', 'MDQ-Sexual Health - Start');
        return <Questionnaire1Screen />;
      case SEXUAL_HEALTH_KEYS.PROFILE:
        trackPageViewGA('/sexual-health/profile', 'MDQ-Sexual Health - Profile');
        return <Questionnaire2Screen />;
      case SEXUAL_HEALTH_KEYS.INVALID:
        trackPageViewGA('/sexual-health/invalid', 'MDQ-Sexual Health - Invalid');
        return <Questionnaire3Screen />;
      case SEXUAL_HEALTH_KEYS.STATEMENT_BEST_APPLIES:
        trackPageViewGA('/sexual-health/statement-best-applies', 'MDQ-Sexual Health - Statement Best Applies');
        return <Questionnaire4Screen />;
      case SEXUAL_HEALTH_KEYS.SELECT_SYMPTOMS:
        trackPageViewGA('/sexual-health/select-symptoms', 'MDQ-Sexual Health - Select Symptoms');
        return <Questionnaire5Screen />;
      case SEXUAL_HEALTH_KEYS.HOW_LONG_HAD_SYMPTOMS:
        trackPageViewGA('/sexual-health/how-long-had-symptoms', 'MDQ-Sexual Health - How Long Had Symptoms');
        return <Questionnaire6Screen />;
      case SEXUAL_HEALTH_KEYS.TAKEN_MEDICATION_OR_SIMILAR_CONDITION_BEFORE:
        trackPageViewGA(
          '/sexual-health/taken-medication-or-similar-condition-before',
          'MDQ-Sexual Health - Taken Medication Or Similar Condition Before',
        );
        return <Questionnaire7Screen />;
      case SEXUAL_HEALTH_KEYS.OTHER_CONDITION_OR_MEDICAL_HISTORY:
        trackPageViewGA(
          '/sexual-health/other-condition-or-medical-history',
          'MDQ-Sexual Health - Other Condition Or Medical History',
        );
        return <Questionnaire8Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default SexualHealth;
